import {FlashRepo, PNode} from '@peachy/flash-repo-pure'
import {PeachyRepoRoot} from '@peachy/repo-domain'

export type PeachyRepoRootNode = PNode<PeachyRepoRoot>
export type PeachyFlashRepo = FlashRepo<PeachyRepoRoot>
